<div class="content">
  <h1>Photo Gallery</h1>
  <p>These are a collection of my photos taken with my Olympus OM-D E-M10 Mark II</p>
</div>
<div class="gallery-list" *ngFor="let picture of pictures">
  <app-picture [picture]="picture"></app-picture>
</div>
